import { getAPI, postAPI } from "../../api"
import { REACT_APP_CUSTOMER, REACT_APP_JOB, REACT_APP_JOBFILTER, REACT_APP_RECRUITER } from "../../utils/common"

export async function getPositions(searchValue : string , page : number, pageSize: number, data?: any){    
    const Details = postAPI( REACT_APP_JOBFILTER + `/position-filter?tab=provider&search=${searchValue}&page=${page}&size=${pageSize}`, data)
    return Details
}

export async function getProviderPositions(searchValue: string, page: number, pageSize: number, providerId: string, tab?: string, data?: any) {
    const Details = postAPI( REACT_APP_JOB + `/provider-position-filter/${providerId}?tab=${tab}&search=${searchValue}&page=${page}&size=${pageSize}`, data)
    return Details
}

export async function getAppliedCandidate(jobId: string , providerId: string){
    const Details = getAPI( REACT_APP_JOB + `/provider-applied-positions/${jobId}?providerId=${providerId}&type=myLeads`)
    return Details
}

export async function getPositionsDetails(jobId: string){
    const Details = getAPI( REACT_APP_JOB + `/position/${jobId}`)
    return Details
}

export async function getAllocatedto() {
    const Details = getAPI( REACT_APP_RECRUITER + "/list")
    return Details
}
export async function applyPositionFilters(data:any) {
    const Details = postAPI( REACT_APP_JOB + '/position-filter', data)
    return Details
}

export async function getCompany() {
    const Details = getAPI( REACT_APP_CUSTOMER + "/customer-list")
    return Details
}
export async function getpositionsName() {
    const Details = getAPI( REACT_APP_JOBFILTER + "/position-title")
    return Details
}




